import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';
import {pillFitSx, pillShapePhoneSx} from 'src/components/common/pillFit.sx';

/**
 * The warning worn as a pill, in the shape every other pill on a card uses.
 *
 * The brand pair rather than `error`, because `error.light` is a mid red and a pill needs a pale
 * ground under dark text - the same pair the destructive line in an action sheet uses, so "something
 * is wrong here" looks like itself across the phone screens.
 */
export const missingBexioPillSx: SxProps<Theme> = {
    ...pillFitSx,
    ...pillShapePhoneSx,
    backgroundColor: theme.palette.brand.light,
    color: theme.palette.brand.dark,
};
